exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".badge___2I4t0 {\n  color: rgba(255, 255, 255, 0.65); }\n  .badge___2I4t0 sup {\n    box-shadow: none;\n    font-size: 11px;\n    min-width: 21px; }\n  .badge___2I4t0:hover {\n    color: #fff; }\n", ""]);

// Exports
exports.locals = {
	"badge": "badge___2I4t0"
};